import React, { useEffect, useState } from 'react';
import { Row, Column } from 'react-foundation';
import MediaUploadButton from './MediaUploadButton';
import {
	postOpportunity,
	putOpportunity,
} from '../../../../api/opportunitiesAPI';
import Tag from './Tag';
import OpportunityButton from './OpportunityButton';
import * as api from '../../../../api/opportunitiesAPI';

/**
 * Function for the new opportunity page
 * @param orgID the organization id
 * @param oppID the opportunity id
 * @constructor
 */
const NewOpportunity = ({ orgID, oppID }) => {
	const opportunityTemplate = {
		name: '',
		timeframe_start_on: '',
		timeframe_end_on: '',
		frequency: '',
		description: '',
		key_benefits: '',
		primary_age_group: '',
		secondary_age_group: '',
		gender: '',
		household_income: '',
		expected_audience: '',
		expected_impressions: '',
		reply_date: '',
		submission_date: '',
		suggested_bid: '',
		published: false,
		property_info_id: 0,
		opportunity_types: [],
		opportunity_locations: [],
		opportunity_hashtags: [],
		assets: [null, null, null, null],
	};

	const fieldDefaultTemplate = {
		ageGroups: [],
		eventFrequencies: [],
		genders: [],
		householdIncomes: [],
		locations: [],
		opportunityTypes: [],
		presenceValidations: [],
	};

	const [opportunityData, setOpportunityData] = useState(opportunityTemplate);
	const emptyFieldMessage = 'Field cannot be left empty!';
	const [headerFileName, setHeaderFileName] = useState('');
	const [bodyMedia1Name, setBodyMedia1Name] = useState('');
	const [bodyMedia2Name, setBodyMedia2Name] = useState('');
	const [sponsorshipDeckName, setSponsorshipDeckName] = useState('');
	const [fieldDefaults, setFieldDefaults] = useState(fieldDefaultTemplate);
	const [formattedLocations, setFormattedLocations] = useState({});
	const [autocomplete, setAutocomplete] = useState(undefined);
	const [requiredFields, setRequiredFields] = useState([]);
	const [cloudinaryUploadWidget, setCloudinaryUploadWidget] =
		useState(undefined);
	const [currentActiveFileComponentName, setCurrentActiveFileComponentName] =
		useState('');
	const [activeFileBuffer, setActiveFileBuffer] = useState(undefined);
	const maxAssets = 4;
	let autocompleteLsr;

	useEffect(() => {
		if (!currentActiveFileComponentName) return;
		console.log('New file buffer: ', activeFileBuffer);
		console.log(
			'Current active file component name: ',
			currentActiveFileComponentName
		);

		let customFileBuffer = activeFileBuffer;
		customFileBuffer.etag = currentActiveFileComponentName;
		customFileBuffer.version = 'upload';
		// new files need to have a nil id or the controller will choke on it
		// Cloudinary puts a strange "uw-file3" value as an id, so we remove it
		customFileBuffer.id = null;

		placeMediaObjectIntoProperIndex(
			customFileBuffer,
			currentActiveFileComponentName
		);
	}, [activeFileBuffer]);

	/**
	 * Handles submission of media, in either a URL to the picture/video or the file itself
	 * @param mediaType the name of the component submitting the file
	 * @param link the link to the URL/file
	 */
	const handleEmbedLinkUpload = (mediaType, link) => {
		console.log('Name: ', mediaType, ' | link: ', link);
		let mimicCloudinaryLinkObject = {
			asset_id: 'link-' + Date.now(),
			etag: mediaType,
			url: link,
			secure_url: link,
			public_id: link,
			version: 'link',
			resource_type: 'link',
		};
		console.log('Mimic Link: ', mimicCloudinaryLinkObject);

		placeMediaObjectIntoProperIndex(mimicCloudinaryLinkObject, mediaType);
	};

	const placeMediaObjectIntoProperIndex = (mediaObject, mediaType) => {
		let mediaTypeAlreadyExists = false;
		let i;
		let firstFreeIndex = -1;
		console.log('Entered Media Type: ', mediaType);
		for (i = 0; i < maxAssets; i++) {
			console.log('Asset Media Type: ', opportunityData?.assets[i]?.etag);
			if (opportunityData?.assets[i]?.etag === mediaType) {
				mediaTypeAlreadyExists = true;
				break;
			} else if (!opportunityData.assets[i]) {
				// If the current index is null, then set the first free index to it
				firstFreeIndex = i;
			}
		}

		// If we already found a version of say header_media, we simply want to replace it.
		if (mediaTypeAlreadyExists || firstFreeIndex !== -1) {
			if (mediaTypeAlreadyExists) {
				opportunityData.assets[i] = mediaObject;
			} else if (firstFreeIndex !== -1) {
				// Otherwise, just stick it in to the first free index
				opportunityData.assets[firstFreeIndex] = mediaObject;
			}
			if (mediaObject.resource_type === 'image') {
				if (mediaObject.format !== 'pdf') {
					document.getElementById(mediaType).style.backgroundImage =
						formatURLForBackground(mediaObject.secure_url);
				} else {
					document.getElementById(mediaType).style.backgroundImage =
						formatVideoThumbnailURL(mediaObject.thumbnail_url);
				}

				if (mediaType === 'body_media_1') {
					setBodyMedia1Name('');
				} else if (mediaType === 'body_media_2') {
					setBodyMedia2Name('');
				} else if (mediaType === 'sponsorship_deck') {
					setSponsorshipDeckName('');
				}
			} else if (mediaObject.resource_type === 'video') {
				document.getElementById(mediaType).style.backgroundImage =
					formatVideoThumbnailURL(mediaObject.thumbnail_url);

				if (mediaType === 'body_media_1') {
					setBodyMedia1Name('');
				} else if (mediaType === 'body_media_2') {
					setBodyMedia2Name('');
				} else if (mediaType === 'sponsorship_deck') {
					setSponsorshipDeckName('');
				}
			} else if (mediaObject.version === 'link') {
				document.getElementById(mediaType).style.backgroundImage = '';

				if (mediaType === 'body_media_1') {
					setBodyMedia1Name(mediaObject.url);
				} else if (mediaType === 'body_media_2') {
					setBodyMedia2Name(mediaObject.url);
				} else if (mediaType === 'sponsorship_deck') {
					setSponsorshipDeckName(mediaObject.url);
				}
			} else {
				if (mediaType === 'body_media_1') {
					setBodyMedia1Name(mediaObject.original_filename);
				} else if (mediaType === 'body_media_2') {
					setBodyMedia2Name(mediaObject.original_filename);
				} else if (mediaType === 'sponsorship_deck') {
					setSponsorshipDeckName(mediaObject.original_filename);
				}
			}
		} else {
			console.error('Something went wrong with storing data');
		}

		setOpportunityData(opportunityData);
		console.log(opportunityData);
	};

	const handleClearingMedia = (name) => {
		let indexToDelete = -1;
		for (let i = 0; i < maxAssets; i++) {
			if (opportunityData?.assets[i]?.etag === name) {
				indexToDelete = i;
				break;
			}
		}

		if (indexToDelete !== -1) {
			opportunityData.assets[indexToDelete] = null;
		}

		setOpportunityData(opportunityData);
		if (document.getElementById(name)) {
			document.getElementById(name).style.backgroundImage = 'none';
		}
		console.log(opportunityData);
	};

	/**
	 * This will call fetchOpportunityData and setMinDates on page load and then set the opportunityData if it exists.
	 * Ie. If we are from the edit screen, and thus have an oppID passed, we should have oppData too
	 */
	useEffect(() => {
		fetchFieldDefaultsAndOppData();

		const center = { lat: 50.064192, lng: -130.605469 };
		// Create a bounding box with sides ~10km away from the center point
		const defaultBounds = {
			north: center.lat + 0.1,
			south: center.lat - 0.1,
			east: center.lng + 0.1,
			west: center.lng - 0.1,
		};

		window.initMap = () => {
			let input = document.getElementById('autocomplete');
			let options = {
				bounds: defaultBounds,
				strictBounds: false,
				fields: ['place_id', 'geometry', 'name'],
				types: ['geocode'],
			};
			setAutocomplete(
				new google.maps.places.Autocomplete(input, options)
			);
			if (autocomplete) {
				autocompleteLsr = autocomplete.addListener(
					'place_changed',
					onPlaceChanged
				);
			}
		};

		// Sets up the upload widget
		$.getScript('https://upload-widget.cloudinary.com/global/all.js').then(
			() => {
				const tempWidget = cloudinary.createUploadWidget(
					{
						cloudName: 'sponsor-circle',
						uploadPreset: 'pv9mlmap',
						multiple: false,
						sources: [
							'local',
							'instagram',
							'google_drive',
							'facebook',
							'shutterstock',
							'gettyimages',
							'istock',
							'unsplash',
						],
					},
					(error, result) => {
						// This should rarely be the case, but if the cap on gallery files is hit, then immediately close the widget
						if (!error && result && result.event === 'success') {
							handleSuccessfulFileUpload(result);
						} else if (error) {
							console.error(error);
						}
					}
				);
				setCloudinaryUploadWidget(tempWidget);
			}
		);
	}, []);

	const openCloudinaryWidget = (name) => {
		setCurrentActiveFileComponentName(name);
		cloudinaryUploadWidget.open();
	};

	const handleSuccessfulFileUpload = (result) => {
		setActiveFileBuffer(result.info);
	};

	/**
	 * Handler function to be called when a user clicks a location from google maps autocomplete widget
	 */
	const onPlaceChanged = () => {
		let place = autocomplete.getPlace();
		if (place.geometry) {
			// Display details about the valid place
			handleOpportunityLocation(place.name);
		}
		// Clear the input field
		document.getElementById('autocomplete').value = '';
	};

	/**
	 * Ensures maps are enabled
	 */
	const checkMapsEnabled = () => {
		autocompleteLsr = autocomplete.addListener(
			'place_changed',
			onPlaceChanged
		);
	};

	/**
	 * Replaces the event handler for autocomplete whenever opportunity data changes. This makes it so the eventListener
	 * is updated with the most current data. (IMPORTANT!)
	 */
	useEffect(() => {
		if (autocomplete !== {} && autocomplete) {
			autocompleteLsr = autocomplete.addListener(
				'place_changed',
				onPlaceChanged
			);
		}

		return () => {
			autocomplete !== {} && autocomplete
				? google.maps.event.removeListener(autocompleteLsr)
				: '';
		};
	}, [opportunityData]);

	/**
	 * Sets the minimum dates
	 */
	const setMinDates = () => {
		let today = new Date();
		let dd = String(today.getDate()).padStart(2, '0');
		let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
		let yyyy = today.getFullYear();
		today = yyyy + '-' + mm + '-' + dd;
		document.getElementById('timeframe-start-on').min = today;
		document.getElementById('timeframe-end-on').min = today;
		document.getElementById('reply_date').min = today;
		document.getElementById('submission_date').min = today;
	};

	/**
	 * Fetches fieldDefaults (and opportunity data if applicable) from the backend. Also updates dropdown fields, and
	 * their selected values, to better line up with what currently exists.
	 */

	const fetchFieldDefaultsAndOppData = async () => {
		try {
			let fieldResponse = await api.getFieldAttributes();
			$.getScript(
				'https://maps.googleapis.com/maps/api/js?key=' +
					fieldResponse.data.googleAPIKey +
					'&libraries=places&callback=initMap'
			);
			setFieldDefaults(fieldResponse.data);
			setRequiredFields(fieldResponse.data.presenceValidations);

			let isTimeframeHeaderEdited = false;
			for (const requiredField of fieldResponse.data
				.presenceValidations) {
				if (
					requiredField === 'timeframe_start_on' ||
					requiredField === 'timeframe_start_on'
				) {
					if (!isTimeframeHeaderEdited) {
						isTimeframeHeaderEdited = true;
						document.getElementById('timeframe-header').innerText +=
							' *';
					}
				} else {
					document.getElementById(
						requiredField + '-header'
					).innerText += ' *';
				}
			}

			// Now fetch the data if opportunity ID exists
			let opportunityResponse = '';
			if (oppID) {
				opportunityResponse = await api.getOpportunity(oppID);
			}

			let response = opportunityResponse;
			if (response !== '' && response !== undefined) {
				let opportunity = response.data;
				if (!opportunity.assets) {
					opportunity.assets = [null, null, null, null];
				}
				setOpportunityData(opportunity);
				// Need to change all opportunity types to just their numbers right here
				let tempArray = [];
				for (let i = 0; i < opportunity.opportunity_types.length; i++) {
					tempArray.push(opportunity.opportunity_types[i].id);
				}
				opportunity.opportunity_types = tempArray;

				console.log(opportunity);

				// Properly allocate the starting assets
				for (const asset of opportunity.assets) {
					if (!asset) continue;
					if (asset.resource_type === 'image' && asset.secure_url) {
						if (asset.format !== 'pdf') {
							document.getElementById(
								asset.etag
							).style.backgroundImage = formatURLForBackground(
								asset.secure_url
							);
						} else {
							document.getElementById(
								asset.etag
							).style.backgroundImage = formatVideoThumbnailURL(
								asset.thumbnail_url
							);
						}
					} else if (
						asset.resource_type === 'video' &&
						asset.thumbnail_url
					) {
						document.getElementById(
							asset.etag
						).style.backgroundImage = formatVideoThumbnailURL(
							asset.thumbnail_url
						);
					} else if (asset.version === 'link' && asset.url) {
						if (asset.etag === 'body_media_1') {
							setBodyMedia1Name(asset.url);
						} else if (asset.etag === 'body_media_2') {
							setBodyMedia2Name(asset.url);
						} else if (asset.etag === 'sponsorship_deck') {
							setSponsorshipDeckName(asset.url);
						}
					} else {
						if (asset.etag === 'body_media_1') {
							setBodyMedia1Name(asset.original_filename);
						} else if (asset.etag === 'body_media_2') {
							setBodyMedia2Name(asset.original_filename);
						} else if (asset.etag === 'sponsorship_deck') {
							setSponsorshipDeckName(asset.original_filename);
						}
					}
				}

				// Change all the values for the dropdowns, to match what already exists if it applies
				if (fieldResponse) {
					let fieldResponseData = fieldResponse.data;
					if (
						fieldResponseData.eventFrequencies.includes(
							opportunity.frequency
						)
					) {
						document.getElementById('frequency').value =
							opportunity.frequency;
					}
					if (
						fieldResponseData.ageGroups.includes(
							opportunity.primary_age_group
						)
					) {
						document.getElementById('primary_age_group').value =
							opportunity.primary_age_group;
					}
					if (
						fieldResponseData.ageGroups.includes(
							opportunity.secondary_age_group
						)
					) {
						document.getElementById('secondary_age_group').value =
							opportunity.secondary_age_group;
					}
					if (
						fieldResponseData.genders.includes(opportunity.gender)
					) {
						document.getElementById('gender').value =
							opportunity.gender;
					}
					if (
						fieldResponseData.householdIncomes.includes(
							opportunity.household_income
						)
					) {
						document.getElementById('household_income').value =
							opportunity.household_income;
					}

					// Set all opportunity types that should be checked to be checked
					for (
						let i = 0;
						i < opportunity.opportunity_types.length;
						i++
					) {
						let currentId = opportunity.opportunity_types[i];
						document.getElementById(
							'sponsorable-opportunity-' + currentId
						).checked = 'true';
					}
				}
			}
		} catch (error) {
			console.error(error);
		}
	};

	/**
	 * Formats the url to include "url(" and ")", to pertain to url standards in css backgroundImage
	 * @param oldURL
	 * @return {string}
	 */
	const formatURLForBackground = (oldURL) => {
		return 'url(' + oldURL + ')';
	};

	/**
	 * Checks whether all required fields (under presenceValidation) are filled out. If not, scrolls the page to the
	 * appropriate field, and prompts to user to fill any unfilled fields out.
	 * @return {boolean} true if all required fields are filled, false if not
	 */
	const areRequiredFieldsFilled = () => {
		const scrollBehavior = { behavior: 'smooth' };
		let allRequiredFieldsFilled = true;
		let hasScrolledAlready = false;

		for (const requiredField of requiredFields) {
			if (
				opportunityData[requiredField] === '' ||
				opportunityData[requiredField].length === 0
			) {
				allRequiredFieldsFilled = false;
				document.getElementById(
					requiredField + '-empty-label'
				).style.display = 'inline-block';
				if (!hasScrolledAlready) {
					if (
						requiredField === 'timeframe_start_on' ||
						requiredField === 'timeframe_end_on'
					) {
						document
							.getElementById('timeframe-header')
							.scrollIntoView(scrollBehavior);
					} else {
						document
							.getElementById(requiredField + '-header')
							.scrollIntoView(scrollBehavior);
					}
					hasScrolledAlready = true;
				}
			} else {
				document.getElementById(
					requiredField + '-empty-label'
				).style.display = 'none';
			}
		}

		return allRequiredFieldsFilled;
	};

	/**
	 * Handles publishing of the opportunity - linked to the 'publish' button at the bottom of the screen
	 */
	const handleSubmit = async () => {
		let allRequiredFieldsFilled = areRequiredFieldsFilled();

		if (allRequiredFieldsFilled) {
			try {
				opportunityData['published'] = true;
				setOpportunityData(opportunityData);
				let response;
				if (oppID !== undefined) {
					await putOpportunity(oppID, opportunityData);
					location.assign(
						`/organizations/${orgID}/property_info/opportunities/${oppID}`
					);
				} else {
					response = await postOpportunity(orgID, opportunityData);
					location.assign(
						`/organizations/${orgID}/property_info/opportunities/${response.data.id}`
					);
				}
			} catch (e) {
				console.error(e);
			}
		}
	};

	/**
	 * Formats hashtags if they've been left on the line. This is really just for edge cases where the user doesn't hit
	 * enter on hashtags
	 */
	const fixHashtags = () => {
		let hashtagsStringInput = document.getElementById(
			'opportunity_hashtags'
		).value;
		if (hashtagsStringInput) {
			let hashtagsArray = hashtagsStringInput.split(/\s+/);
			let hashtagsToAddArray = [];
			for (let hashtag of hashtagsArray) {
				hashtag = hashtag[0] === '#' ? hashtag : '#' + hashtag;
				hashtag = hashtag.replace(' ', '');
				if (
					hashtag.trim() === '#' ||
					opportunityData.opportunity_hashtags.some(
						(h) => h.name === hashtag
					)
				) {
					continue;
				}
				hashtagsToAddArray.push({ name: hashtag });
			}
			setOpportunityData({
				...opportunityData,
				opportunity_hashtags: [
					...opportunityData.opportunity_hashtags,
					...hashtagsToAddArray,
				],
			});
			document.getElementById('opportunity_hashtags').value = '';
		}
	};

	/**
	 * Handles saving of the form - linked to the 'save work' button at the bottom of the screen
	 */
	const handleSave = async () => {
		let allRequiredFieldsFilled = areRequiredFieldsFilled();

		try {
			if (allRequiredFieldsFilled) {
				if (oppID === undefined) {
					const response = await postOpportunity(
						orgID,
						opportunityData
					);
					oppID = response.data.id;
					location.assign(
						`/organizations/${orgID}/property_info/opportunities/${response.data.id}`
					);
				} else {
					await putOpportunity(oppID, opportunityData);
					location.assign(
						`/organizations/${orgID}/property_info/opportunities/${oppID}`
					);
				}
			}
		} catch (e) {
			console.error(e);
		}
	};

	/**
	 * Handles a change in an input field
	 * @param event the event
	 */
	const handleChange = (event) => {
		opportunityData[event.target.name] = event.target.value;
		setOpportunityData(opportunityData);
	};

	/**
	 * Any time a required field is changed, we check to see if all fields are filled out
	 * @param event
	 */
	const handleChangeWithEmptyFieldCheck = (event) => {
		opportunityData[event.target.name] = event.target.value;
		setOpportunityData(opportunityData);

		if (requiredFields.includes(event.target.name)) {
			if (event.target.value === '') {
				document.getElementById(
					event.target.name + '-empty-label'
				).style.display = 'inline-block';
			} else {
				document.getElementById(
					event.target.name + '-empty-label'
				).style.display = 'none';
			}
		}
	};

	/**
	 * Handles clicking of a checkbox under the 'sponsorable opportunities' section.
	 * @param event the event of the checkbox clicked
	 */
	const handleCheckboxes = (event) => {
		// If the target has now become checked, then add the data to our opportunityData object
		if (event.target.checked) {
			let currentType;
			for (let i = 0; i < fieldDefaults.opportunityTypes.length; i++) {
				if (
					String(event.target.name) ===
					String(fieldDefaults.opportunityTypes[i].id)
				) {
					currentType = fieldDefaults.opportunityTypes[i];
					break;
				}
			}

			if (currentType) {
				opportunityData.opportunity_types.push(
					parseInt(event.target.name)
				);
				setOpportunityData(opportunityData);
			}
		} else {
			// If the target has just become unchecked, then remove it from our stored opportunityData object
			opportunityData.opportunity_types.forEach(
				(sponsorableOpportunity, index) => {
					if (
						String(sponsorableOpportunity) ===
						String(event.target.name)
					) {
						opportunityData.opportunity_types.splice(index, 1);
						setOpportunityData(opportunityData);
					}
				}
			);
		}
	};

	/**
	 * Handles hashtags
	 * @param event the event of adding a hashtag
	 */
	const handleHashTag = (event) => {
		// First edit the hashtag if needed, to have # in the beginning, and no spaces
		let value = event.target.value;
		value = value[0] === '#' ? value : '#' + value;
		value = value.replace(' ', '');

		// If we're left with just # (meaning an empty string) or value is already included, do nothing
		if (
			value.trim() === '#' ||
			opportunityData.opportunity_hashtags.some((h) => h.name === value)
		) {
			event.target.value = '';
			return;
		}

		setOpportunityData({
			...opportunityData,
			opportunity_hashtags: [
				...opportunityData.opportunity_hashtags,
				{ name: value },
			],
		});
		event.target.value = '';
	};

	/**
	 * Handles the addition of another opportunity location
	 * @param placeName the event of the opportunity location clicked
	 */
	const handleOpportunityLocation = (placeName) => {
		let newLocation = placeName;
		// Check the current locations to see if it's already included
		let found = false;
		for (let i = 0; i < opportunityData.opportunity_locations.length; i++) {
			if (
				opportunityData.opportunity_locations[i].location ===
				newLocation
			) {
				found = true;
				break;
			}
		}

		if (!found) {
			setOpportunityData({
				...opportunityData,
				opportunity_locations: [
					...opportunityData.opportunity_locations,
					{ location: newLocation },
				],
			});
		}
		document.getElementById(
			'opportunity_locations-empty-label'
		).style.display = 'none';
	};

	/**
	 * Handles clicking of any tag, and removing it from opportunityData
	 * @param i the index of the tag
	 * @param type the type of tag
	 */
	const handleClick = (i, type) => {
		opportunityData[type].splice(i, 1);
		setOpportunityData({
			...opportunityData,
			[type]: opportunityData[type],
		});
	};

	/**
	 * Handles clicking of locations tag, and checks to see if empty input field label needs to be activated
	 * @param i the index of the location
	 */
	const handleClickLocations = (i) => {
		opportunityData.opportunity_locations.splice(i, 1);
		setOpportunityData({
			...opportunityData,
			opportunity_locations: opportunityData['opportunity_locations'],
		});

		if (opportunityData.opportunity_locations.length === 0) {
			document.getElementById(
				'opportunity_locations-empty-label'
			).style.display = 'inline-block';
		}
	};

	/**
	 * Handles cancelling of the form, and bringing the user back to the organization page
	 */
	const handleCancel = () => {
		location.assign(`/organizations/${orgID}`);
	};

	/**
	 * For linking to the example page
	 */
	const redirectExample = () => {
		window.open('https://sponsorcircle.com/italfestpasta', '_blank');
	};

	const isSponsorableOpportunityChecked = (name) => {
		for (let i = 0; i < opportunityData.opportunity_types.length; i++) {
			if (
				String(opportunityData.opportunity_types[i].id) === String(name)
			) {
				return true;
			}
		}
		return false;
	};

	const formatVideoThumbnailURL = (thumbnail_url) => {
		let tempURL = thumbnail_url.replace('c_limit,h_60,w_90/', '');
		console.log(tempURL);
		return formatURLForBackground(tempURL);
	};

	return (
		<div id="new-opportunity">
			<Row>
				<Column>
					<OpportunityButton
						text="Back to organization profile"
						className="back-link"
						handleSubmit={handleCancel}
						isBackLink={true}
						leftButtonText="Cancel"
						rightButtonText="Exit"
						headerText="You have unsaved content. Would you like to exit and lose your work?"
					/>
					<h1>
						Create your campaign/opportunity to share with potential partners
					</h1>
					<div className="example">
						<p className="body-font right-16px-margin">
							View an example to learn how impactful your campaign
							can be!
						</p>
						<div
							className="primary-button"
							onClick={redirectExample}
						>
							<p>View Example</p>
						</div>
					</div>
				</Column>
			</Row>

			<Row>
				<Column>
					<div className="card" id="header_media">
						<div id="main-opportunity-info" className="card">
							<div className="card-inner">
								<div className="upload-header-image-wrapper">
									<MediaUploadButton
										name="header_media"
										handleMediaSubmission={
											handleEmbedLinkUpload
										}
										text="Upload header image"
										icon={true}
										className="header-media-button float-right"
										setMediaFileName={setHeaderFileName}
										orgID={orgID}
										handleClearingMedia={
											handleClearingMedia
										}
										openCloudinaryWidget={
											openCloudinaryWidget
										}
									/>
								</div>
								<h5
									className="header-font top-bottom-10px-margin"
									id="name-header"
								>
									Name of campaign
								</h5>
								<input
									className="required-input-field body-font-important"
									type="text"
									name="name"
									onChange={handleChangeWithEmptyFieldCheck}
									placeholder="Name of your event, cause or experience"
									defaultValue={opportunityData.name}
									key={`${Math.floor(
										Math.random() * 1000
									)}-min`}
								/>
								<div>
									<label
										className="empty-field-label"
										id="name-empty-label"
									>
										{emptyFieldMessage}
									</label>
								</div>

								<h5
									className="header-font top-bottom-10px-margin"
									id="timeframe-header"
								>
									Timeframe
								</h5>
								<Row className="timeframe">
									<Column medium={6}>
										<p className="body-font no-bottom-margin">
											from
										</p>
										<input
											className="required-input-field body-font-important"
											type="date"
											name="timeframe_start_on"
											onChange={
												handleChangeWithEmptyFieldCheck
											}
											id="timeframe-start-on"
											key={`${Math.floor(
												Math.random() * 1000
											)}-min`}
											defaultValue={
												opportunityData.timeframe_start_on
											}
											onFocus={setMinDates}
										/>
										<label
											className="empty-field-label"
											id="timeframe_start_on-empty-label"
										>
											{emptyFieldMessage}
										</label>
									</Column>

									<Column medium={6}>
										<p className="body-font no-bottom-margin">
											to
										</p>
										<input
											className="required-input-field body-font-important"
											type="date"
											name="timeframe_end_on"
											onChange={
												handleChangeWithEmptyFieldCheck
											}
											id="timeframe-end-on"
											key={`${Math.floor(
												Math.random() * 1000
											)}-min`}
											defaultValue={
												opportunityData.timeframe_end_on
											}
											onFocus={setMinDates}
										/>
										<label
											className="empty-field-label"
											id="timeframe_end_on-empty-label"
										>
											{emptyFieldMessage}
										</label>
									</Column>
								</Row>

								<h5
									className="header-font top-bottom-10px-margin"
									id="frequency-header"
								>
									How often does this occur?
								</h5>
								<select
									className="body-font"
									name="frequency"
									onChange={handleChange}
									defaultValue={opportunityData.frequency}
									id="frequency"
									key={`${Math.floor(
										Math.random() * 1000
									)}-min`}
								>
									<option value="" disabled />
									{fieldDefaults.eventFrequencies.map(
										(o, i) => {
											return (
												<option value={o} key={i + o}>
													{o}
												</option>
											);
										}
									)}
								</select>
								<h5
									className="header-font top-bottom-10px-margin"
									id="opportunity_locations-header"
								>
									Campaign location(s)
								</h5>
								<input
									className="required-input-field body-font-important"
									id="autocomplete"
									type="text"
									placeholder="For events, enter all of the locations. For brands, tell us where you want to showcase your organization"
									name="opportunity_locations"
									onFocus={checkMapsEnabled}
								/>
								<label
									className="empty-field-label"
									id="opportunity_locations-empty-label"
								>
									{emptyFieldMessage}
								</label>
								<ul className="tag-container">
									{opportunityData.opportunity_locations
										? opportunityData.opportunity_locations.map(
												(tag, i) => {
													return (
														<Tag
															key={i + tag}
															name={tag.location}
															index={i}
															handleClick={
																handleClickLocations
															}
															type="opportunity_locations"
															showCloseIcon={true}
														/>
													);
												}
										  )
										: ''}
								</ul>
							</div>
						</div>
					</div>
				</Column>
			</Row>

			<Row>
				<Column medium={6} small={12}>
					<div className="card negative-margin-right">
						<div className="card-inner">
							<h5
								className="header-font top-bottom-10px-margin"
								id="description-header"
							>
								Describe the campaign
							</h5>
							<p className="body-font top-bottom-10px-margin">
								Tell us about you! For events, cause or
								experience, please provide a detailed
								description of your event. If you are a brand,
								what do you want to achieve? Experiential? In
								kind services? Sampling?
							</p>
							<textarea
								className="textarea body-font"
								id="description-textarea"
								name="description"
								onChange={handleChangeWithEmptyFieldCheck}
								defaultValue={opportunityData.description}
								key={`${Math.floor(Math.random() * 1000)}-min`}
							/>
							<label
								className="empty-field-label"
								id="description-empty-label"
							>
								{emptyFieldMessage}
							</label>
						</div>
					</div>
				</Column>
				<Column medium={6} small={12}>
					<div
						className="card negative-margin-left"
						id="body_media_1"
					>
						<div className="important-wrapper">
							<MediaUploadButton
								name="body_media_1"
								handleMediaSubmission={handleEmbedLinkUpload}
								text="Upload/embed media"
								icon={true}
								className="center"
								setMediaFileName={setBodyMedia1Name}
								orgID={orgID}
								handleClearingMedia={handleClearingMedia}
								openCloudinaryWidget={openCloudinaryWidget}
							/>
						</div>
						{bodyMedia1Name ? (
							<label className="card-file-name">
								Current file: {bodyMedia1Name}
							</label>
						) : (
							''
						)}
					</div>
				</Column>
			</Row>

			<Row>
				<Column medium={6} small={12}>
					<div className="card negative-margin-right">
						<div className="card-inner">
							<h5
								className="header-font top-bottom-10px-margin"
								id="key_benefits-header"
							>
								Key benefits
							</h5>
							<p className="body-font top-bottom-10px-margin">
								Please provide a detailed overview of how your
								campaign can benefit your potential partner
							</p>
							<textarea
								className="textarea body-font"
								id="key-benefits-textarea"
								name="key_benefits"
								onChange={handleChange}
								defaultValue={opportunityData.key_benefits}
								key={`${Math.floor(Math.random() * 1000)}-min`}
							/>
						</div>
					</div>
				</Column>
				<Column medium={6} small={12}>
					<div
						className="card negative-margin-left"
						id="body_media_2"
					>
						<div className="important-wrapper">
							<MediaUploadButton
								name="body_media_2"
								handleMediaSubmission={handleEmbedLinkUpload}
								text="Upload/embed media"
								icon={true}
								className="center"
								setMediaFileName={setBodyMedia2Name}
								orgID={orgID}
								handleClearingMedia={handleClearingMedia}
								openCloudinaryWidget={openCloudinaryWidget}
							/>
						</div>
						{bodyMedia2Name ? (
							<label className="card-file-name">
								Current file: {bodyMedia2Name}
							</label>
						) : (
							''
						)}
					</div>
				</Column>
			</Row>

			<Row>
				<Column medium={6} small={12}>
					<div
						className="card negative-margin-right"
						id="at-a-glance"
					>
						<div className="card-inner">
							<h5 className="header-font top-bottom-10px-margin">
								At a glance
							</h5>
							<p
								className="body-font bold top-bottom-10px-margin"
								id="primary_age_group-header"
							>
								Tell us more about your desired or existing
								audience. What is the primary age group?
							</p>
							<select
								className="body-font"
								name="primary_age_group"
								onChange={handleChange}
								defaultValue={opportunityData.primary_age_group}
								id="primary_age_group"
							>
								<option value="" disabled />
								{fieldDefaults.ageGroups.map((o, i) => {
									return (
										<option value={o} key={i + o}>
											{o}
										</option>
									);
								})}
							</select>
							<p
								className="body-font bold top-bottom-10px-margin"
								id="secondary_age_group-header"
							>
								Tell us more about your desired or existing
								audience. What is the secondary age group?
							</p>
							<select
								className="body-font"
								name="secondary_age_group"
								onChange={handleChange}
								defaultValue={
									opportunityData.secondary_age_group
								}
								id="secondary_age_group"
							>
								<option value="" disabled />
								{fieldDefaults.ageGroups.map((o, i) => {
									return (
										<option value={o} key={i + o}>
											{o}
										</option>
									);
								})}
							</select>
							<p
								className="body-font bold top-bottom-10px-margin"
								id="gender-header"
							>
								Tell us more about your desired or existing
								audience. What is the primary gender?
							</p>
							<select
								className="body-font"
								name="gender"
								onChange={handleChange}
								defaultValue={opportunityData.gender}
								id="gender"
							>
								<option value="" disabled />
								{fieldDefaults.genders.map((o, i) => {
									return (
										<option value={o} key={i + o}>
											{o}
										</option>
									);
								})}
							</select>
							<p
								className="body-font bold top-bottom-10px-margin"
								id="household_income-header"
							>
								Tell us more about your desired or existing
								audience. What is the average annual household
								income?
							</p>
							<select
								className="body-font"
								name="household_income"
								onChange={handleChange}
								defaultValue={opportunityData.household_income}
								id="household_income"
							>
								<option value="" disabled />
								{fieldDefaults.householdIncomes.map((o, i) => {
									return (
										<option value={o} key={i + o}>
											{o}
										</option>
									);
								})}
							</select>

							<p
								className="body-font bold top-bottom-10px-margin"
								id="expected_audience-header"
							>
								What is the total desired/expected in person
								audience? (participants and spectators)
							</p>
							<input
								className="body-font-important"
								type="number"
								name="expected_audience"
								onChange={handleChange}
								defaultValue={opportunityData.expected_audience}
							/>

							<p
								className="body-font bold top-bottom-10px-margin"
								id="expected_impressions-header"
							>
								What is the total desired/expected impressions?
								(digital, promotional, social, onsite)
							</p>
							<input
								className="body-font-important"
								type="number"
								name="expected_impressions"
								onChange={handleChange}
								defaultValue={
									opportunityData.expected_impressions
								}
							/>

							<p
								className="body-font bold top-bottom-10px-margin"
								id="opportunity_types-header"
							>
								Select the supplier and sponsorable
								opportunities (all that apply)
							</p>
							<div
								id="opportunities-check-box"
								className="check_boxes row"
							>
								<div className="columns small-12 button-group">
									{fieldDefaults.opportunityTypes.map(
										(interestObject) => {
											return (
												<div
													className="sponsorable-opportunity tag-button hollow"
													id={interestObject.id}
													key={interestObject.name}
												>
													<label>
														<input
															type="checkbox"
															value={
																interestObject.name
															}
															className="opportunity"
															name={
																interestObject.id
															}
															id={
																'sponsorable-opportunity-' +
																interestObject.id
															}
															onClick={
																handleCheckboxes
															}
															defaultChecked={
																oppID
																	? () =>
																			isSponsorableOpportunityChecked(
																				'sponsorable-opportunity-' +
																					interestObject.id
																			)
																	: false
															}
														/>
														<div className="checkbox-name">
															<p>
																{
																	interestObject.name
																}
															</p>
														</div>
													</label>
												</div>
											);
										}
									)}
								</div>
							</div>
							<p
								className="body-font bold top-bottom-10px-margin"
								id="opportunity_hashtags-header"
							>
								Add hashtags to be more searchable!
							</p>
							<input
								className="body-font-important"
								type="text"
								name="opportunity_hashtags"
								onKeyPress={(e) =>
									e.key === 'Enter' && handleHashTag(e)
								}
								id="opportunity_hashtags"
								onBlur={fixHashtags}
							/>
							<ul className="tag-container">
								{opportunityData.opportunity_hashtags
									? opportunityData.opportunity_hashtags.map(
											(tag, i) => {
												return (
													<Tag
														key={i + tag}
														name={tag.name}
														index={i}
														handleClick={
															handleClick
														}
														type="opportunity_hashtags"
														showCloseIcon={false}
													/>
												);
											}
									  )
									: ''}
							</ul>
						</div>
					</div>
				</Column>
				<Column medium={6} small={12}>
					<div className="card negative-margin-left">
						<div className="card-inner vcenter">
							<p
								className="body-font bold top-bottom-10px-margin"
								id="reply_date-header"
							>
								Reply with interest by
							</p>
							<input
								className="required-input-field body-font-important"
								name="reply_date"
								type="date"
								onChange={handleChangeWithEmptyFieldCheck}
								defaultValue={opportunityData.reply_date}
								id="reply_date"
								key={`${Math.floor(Math.random() * 1000)}-min`}
								onFocus={setMinDates}
							/>
							<label
								className="empty-field-label"
								id="reply_date-empty-label"
							>
								{emptyFieldMessage}
							</label>

							<p
								className="body-font bold top-bottom-10px-margin"
								id="submission_date-header"
							>
								Submit proposal by
							</p>
							<input
								className="required-input-field body-font-important"
								name="submission_date"
								type="date"
								onChange={handleChangeWithEmptyFieldCheck}
								defaultValue={opportunityData.submission_date}
								id="submission_date"
								key={`${Math.floor(Math.random() * 1000)}-min`}
								onFocus={setMinDates}
							/>
							<label
								className="empty-field-label"
								id="submission_date-empty-label"
							>
								{emptyFieldMessage}
							</label>

							<p
								className="body-font bold top-bottom-10px-margin"
								id="suggested_bid-header"
							>
								Suggested bid
							</p>
							<input
								className="body-font-important"
								name="suggested_bid"
								type="number"
								onChange={handleChange}
								placeholder="Enter dollar amount"
								defaultValue={opportunityData.suggested_bid}
								key={`${Math.floor(Math.random() * 1000)}-min`}
							/>
						</div>
					</div>
					<div
						className="card negative-margin-left"
						id="sponsorship_deck"
					>
						<div className="important-wrapper">
							<MediaUploadButton
								name="sponsorship_deck"
								handleMediaSubmission={handleEmbedLinkUpload}
								text="Upload sponsorship deck"
								icon={false}
								className="center"
								setMediaFileName={setSponsorshipDeckName}
								orgID={orgID}
								handleClearingMedia={handleClearingMedia}
								openCloudinaryWidget={openCloudinaryWidget}
							/>
						</div>
						{sponsorshipDeckName ? (
							<label className="card-file-name">
								Current file: {sponsorshipDeckName}
							</label>
						) : (
							''
						)}
					</div>
				</Column>
			</Row>

			<Row>
				<Column small={12}>
					<div className="clearfix">
						<OpportunityButton
							text="Cancel"
							className="secondary-button hollow float-left"
							handleSubmit={handleCancel}
							isBackLink={false}
							leftButtonText="Cancel"
							rightButtonText="Exit"
							headerText="You have unsaved content. Would you like to exit and lose your work?"
						/>
						<OpportunityButton
							text="Publish"
							className="primary-button float-right left-2rem-margin push-down-on-mobile"
							handleSubmit={handleSubmit}
							isBackLink={false}
							leftButtonText="Cancel"
							rightButtonText="Continue"
							headerText="Your campaign will be visible to the public once published."
						/>
						<div
							className="secondary-button float-right push-up-on-mobile"
							onClick={handleSave}
						>
							<p>Save Work</p>
						</div>
					</div>
				</Column>
			</Row>
		</div>
	);
};

export default NewOpportunity;
